module.exports = __webpack_public_path__ + "static/43-GDPR-may2018-option1-5057a34688d10c7e70cddcc5a0d0fe3b.jpg";